<template>
	<div
		class="cassie-vertical-md"
	>
		<PreferenceWidgetPreferencesCard
			:preference-widget="preferenceWidget"
			:update-preference-widget="updatePreferenceWidget"
			:channels="channels"
			:user-full-permissions="userFullPermissions"
		/>
		<ExtendedPreferencesCard
			is-preference-widget
			:preferences="preferenceWidgetStatementGroups"
			:extended-preferences="preferenceWidget.extendedPreferences || []"
			@update:extendedPreferences="value => updatePreferenceWidget('extendedPreferences', value)"
		/>
		<PreferenceWidgetPreviewCard
			v-if="preferenceWidgetStatementGroups.length"
			:preference-widget="preferenceWidget"
			:extended-preferences="preferenceWidget.extendedPreferences || []"
			:user-full-permissions="userFullPermissions"
			:channels="channels"
			:headers="headers"
			:footers="footers"
		/>
	</div>
</template>
<script>
import ExtendedPreferencesCard from '../../shared/extended-preferences-card.vue'
import PreferenceWidgetPreferencesCard from './preference-widget-preferences-card.vue'
import PreferenceWidgetPreviewCard from './preference-widget-preview-card.vue'

export default {
	components: {
		PreferenceWidgetPreviewCard,
		PreferenceWidgetPreferencesCard,
		ExtendedPreferencesCard
	},
	props: {
		preferenceWidget: {
			type: Object,
			default: () => ({})
		},
		lookupData: {
			type: Object,
			default: () => ({})
		},
		channels: {
			type: Array,
			default: () => []
		},
		headers: {
			type: Array,
			default: () => []
		},
		footers: {
			type: Array,
			default: () => []
		},
		userFullPermissions: Boolean,
		editMode: Boolean
	},
	data () {
		return {
			showExtendedPreferences: false,
			isEdit: false
		}
	},
	computed: {
		preferenceWidgetStatementGroups () {
			return this.preferenceWidget.statementGroups || []
		}
	},
	methods: {
		updatePreferenceWidget (property, value) {
			this.$emit('update:preferenceWidget', {
				...this.preferenceWidget,
				[property]: value
			})
		}
	}
}
</script>
